"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatSecurityTip = void 0;
var _TipBox = _interopRequireDefault(require("../../../TipBox"));
var _dsIcons = require("@olxbr/ds-icons");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ChatSecurityTip = exports.ChatSecurityTip = function ChatSecurityTip() {
  var tipText = 'Negocie pelo chat da OLX e tenha uma experiência ' + 'muito mais segura';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TipBox["default"], {
    tip: {
      icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsIcons.TrustShield, {}),
      text: tipText,
      cta: null,
      links: {
        web: null
      }
    },
    variant: "default"
  });
};